module.exports = __webpack_public_path__ + "img/biaoqian_bowuguan.97d0f3b9.png";